import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import './SubmittedPrevetInfo.scss';
import { EmvioButton } from '@nexio/emvio-form-components';
import MerchantDetailsCard from '../MerchantDetailsCard';
import { getIsCreatingApplication } from '../../LeadToLive/createApplicationEntity';

export const SubmittedPrevetInfo = ({ merchantDetails, onToggleModal, isCreating }) => {
    const prevetData = _.get(merchantDetails, 'prevetData', {});
    const onlineApplicationId = _.get(merchantDetails, 'detail.onlineApplicationId', '');
    const [status, setStatus] = useState(merchantDetails.detail.status || '');

    useEffect(() => {
        setStatus(merchantDetails.detail.status);
    }, [merchantDetails.detail.status]);

    const handleEditPrevet = () => {
        const supportingDocuments = _.get(merchantDetails, 'onboardingDocuments', []);
        const doesRecurringBillingValue = _.get(prevetData, 'doesRecurringBilling');
        const doesRecurringBilling = doesRecurringBillingValue == null ? '' : (doesRecurringBillingValue ? 'yes' : 'no');
        const prevetDataWithDocuments = {
            ...prevetData,
            supportingDocuments: supportingDocuments,
            doesRecurringBilling: doesRecurringBilling
        };
        onToggleModal('editPrevet', prevetDataWithDocuments);
    };

    const handleStartApplication = () => {
        const prevetId = _.get(prevetData, 'id');

        if (!prevetId) {
            return;
        }

        onToggleModal('createApplicationModal', {
            isNewApplication: false,
            prevetId: prevetId
        });
    };

    const renderSupportingDocuments = (documents) => {
        if (!documents || !Array.isArray(documents) || documents.length === 0) {
            return <span className="prevet-empty-value">No documents</span>;
        }

        return (
            <div className="prevet-documents">
                {documents.map((doc) => (
                    <span
                        key={doc.id}
                        className="prevet-document-link"
                    >
                        {doc.documentName}
                    </span>
                ))}
            </div>
        );
    };

    const legalName = _.get(prevetData, 'legalName') || '—';
    const websiteUrl = _.get(prevetData, 'webAddress') || '—';
    const description = _.get(prevetData, 'productsServicesOffered') || '—';

    const expectedMonthlyVolumeValue = _.get(prevetData, 'monthlyVolume');
    const expectedMonthlyVolume = _.isNumber(expectedMonthlyVolumeValue) ? expectedMonthlyVolumeValue : '—';

    const ticketSizeValue = _.get(prevetData, 'averageSalesAmount');
    const ticketSize = _.isNumber(ticketSizeValue) ? ticketSizeValue : '—';

    const fulfillmentTimeframe = _.get(prevetData, 'fulfillmentPeriod') || '—';
    const doesRecurringBillingValue = _.get(prevetData, 'doesRecurringBilling');
    const isSubscriptionRecurring = doesRecurringBillingValue == null ? '—' : (doesRecurringBillingValue ? 'Yes' : 'No');

    const yearsInBusinessValue = _.get(prevetData, 'yearsInBusiness');
    const yearsInBusiness = _.isNumber(yearsInBusinessValue) ? yearsInBusinessValue : '—';

    const additionalNotes = _.get(prevetData, 'notes') || '—';
    const supportingDocuments = _.get(merchantDetails, 'onboardingDocuments', []);

    const formattedUrl = websiteUrl.startsWith('http')
        ? websiteUrl
        : `https://${websiteUrl}`;

    return (
        <MerchantDetailsCard title="Submitted Pre-Vet Information" startOpen={status === 'prevet' ? true : false}>
            <div className="prevet-info-content">
                <div className="prevet-list">
                    <div className="prevet-field">
                        <label className="prevet-field-label">Legal Name</label>
                        <div className="prevet-field-value">{legalName}</div>
                    </div>

                    <div className="prevet-field">
                        <label className="prevet-field-label">Website URL</label>
                        <div className="prevet-field-value">
                            {websiteUrl && websiteUrl !== '—' ? (
                                <a href={formattedUrl} target="_blank" rel="noopener noreferrer">
                                    {websiteUrl}
                                </a>
                            ) : '—'}
                        </div>
                    </div>

                    <div className="prevet-field">
                        <label className="prevet-field-label">Description Of Products And Services Offered</label>
                        <div className="prevet-field-value">{description}</div>
                    </div>

                    <div className="prevet-field">
                        <label className="prevet-field-label">Expected Monthly Volume</label>
                        <div className="prevet-field-value">{expectedMonthlyVolume}</div>
                    </div>

                    <div className="prevet-field">
                        <label className="prevet-field-label">Ticket Size</label>
                        <div className="prevet-field-value">{ticketSize}</div>
                    </div>

                    <div className="prevet-field">
                        <label className="prevet-field-label">Fulfillment Timeframe</label>
                        <div className="prevet-field-value">{fulfillmentTimeframe}</div>
                    </div>

                    <div className="prevet-field">
                        <label className="prevet-field-label">Subscription/Recurring?</label>
                        <div className="prevet-field-value">{isSubscriptionRecurring}</div>
                    </div>

                    <div className="prevet-field">
                        <label className="prevet-field-label">Years In Business</label>
                        <div className="prevet-field-value">{yearsInBusiness}</div>
                    </div>

                    <div className="prevet-field">
                        <label className="prevet-field-label">Supporting Documents</label>
                        <div className="prevet-field-value">
                            {renderSupportingDocuments(supportingDocuments)}
                        </div>
                    </div>

                    <div className="prevet-field">
                        <label className="prevet-field-label">Additional Notes</label>
                        <div className="prevet-field-value prevet-field-value-notes">{additionalNotes}</div>
                    </div>
                </div>

                {!onlineApplicationId && (
                    <div className="prevet-actions">
                        <EmvioButton
                            onClick={handleEditPrevet}
                            variant="secondary"
                        >
                            Edit Pre-Vet
                        </EmvioButton>
                        <EmvioButton
                            onClick={handleStartApplication}
                            variant="primary"
                            disabled={isCreating}
                            isLoading={isCreating}
                        >
                            Start Application
                        </EmvioButton>
                    </div>
                )}
            </div >
        </MerchantDetailsCard>
    );
};

function mapStateToProps(state) {
    return {
        isCreating: getIsCreatingApplication(state)
    };
}

export default connect(mapStateToProps)(SubmittedPrevetInfo);
